module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-5-2dcd6723c4f2067cb10acf6c922f8a49.jpg";